var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81 1.046L9.75.993l-.06.053H3.656L0 5.955l9.083 10.29.667.755.667-.756L19.5 5.954l-3.656-4.908H9.81zm-1.255 1h-4l.631 2.968 3.369-2.968zM6.199 5.454h7.102L9.75 2.326 6.2 5.454zm8.115-.44l-3.369-2.968h4l-.631 2.968zM9.75 14.926l4.08-8.472H5.67l4.08 8.473zm1.846-1.529l3.343-6.943h2.786l-6.129 6.943zm3.647-7.943h2.637L15.83 2.7l-.586 2.754zM3.67 2.7l.586 2.754H1.62L3.67 2.7zm4.233 10.697l-6.13-6.943h2.787l3.343 6.943z",
    fill: "#572DA5"
  })));
}
SvgBonus.displayName = 'Bonus';
export default SvgBonus;